// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 840) return "static/chunks/bab91655-3438f56e76e68897.js";
	if (chunkId === 725) return "static/chunks/98bef5de-0badd3c5780790fd.js";
	if (chunkId === 736) return "static/chunks/736-c09aa8242902f4a1.js";
	if (chunkId === 1) return "static/chunks/1-5e691150a5176f1c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"246":"436822e6f2b13584","766":"90115c1bbe117638","944":"34e9922bc3400608","983":"254389e95a003701"}[chunkId] + ".js";
};